import React, {
    useCallback,
    useEffect,
    useMemo,
    useState
} from "react";
import { connect } from "react-redux";
import {
    Badge,
    Button,
    Card,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Input,
    Table
} from "reactstrap";
import VWPagination from "../../components/vwPagination/vwPagination";
import NoRecord from "../../components/NoRecords/noRecords";
import VWLoading from "../../components/vwLoading/vwLoading";
import Skeleton from "../../components/vwSkeleton/vwSkeleton"
import { getPager } from "../../helper/common";
import { SUPER_ADMIN } from "../../store/users/role.constants";
import Message from "../../CommonData/Data/Message";
import moment from 'moment';
import UITooltip from "../../CommonData/Data/UITooltip";
import VWModel from "../../components/vwModal/vwModal";
import {
    closeReturnApprovalActionModal,
    getReturnApprovalsList,
    openReturnApprovalActionModal,
    setPageSizeGlobalReturn,
    setReturnStatus,
    setSelectedRequestId
} from "../../store/returnApprovals/actions";
import ApproveOrRejectReturn from "./ApproveOrRejectReturn";
import debounce from "lodash/debounce";
import Async from "react-select/async";
import { getReasonForAsyncSelect } from "../../store/returnRequests/actions";

const style = {
    table: {
        width: '100%',
        display: 'table',
        borderSpacing: 0,
        borderCollapse: 'separate',
    },
    th: {
        top: 0,
        left: 0,
        zIndex: 2,
        position: 'sticky',
        backgroundColor: '#fff',
    },
};

const customStyles = {
    container: (provided) => ({
        ...provided,
        fontWeight: 'normal',
    }),
    control: (provided) => ({
        ...provided,
        fontWeight: 'normal',
        //minWidth: '250px',
        minHeight: "30px",
        height: "30px",
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: "2px 8px",
        height: "30px",
    }),
    option: (provided, state) => ({
        ...provided,
        fontWeight: 'normal'
    }),
    input: (provided) => ({
        ...provided,
        margin: "0px",
        padding: "0px",
    }),
    singleValue: (provided) => ({
        ...provided,
        fontSize: "14px",
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        height: "30px",
    }),
};
const ReturnApprovalsList = (props) => {
    const { returnApprovals, returnStatus, isGetReturnApprovalsPending, isReturnApprovalActionModalOpen, errorMessage, currentProfile, isApprovalRejectedSuccess } = props;
    const [pageSize, setPageSize] = useState(10);
    const [pager, setPager] = useState({ currentPage: 1 });
    const [filter, setFilter] = useState({ requestStatus: 'Submitted' });
    const [filterDisplay, setFilterDisplay] = useState();

    const isSuperAdmin = currentProfile.roles && currentProfile.roles.length > 0 &&
        (currentProfile.roles[0].roleKey === SUPER_ADMIN);
    //-----------------------Filter-------------------------------------
    const buildQueryDeviceKey = () => {
        const { deviceKey } = filter || {};
        let searchDeviceKey = '';
        if (deviceKey) {
            searchDeviceKey += `${deviceKey}`;
        }
        return searchDeviceKey
    }

    const buildQueryRequestStatus = () => {
        const { requestStatus } = filter || {};
        let searchRequestReason = '';
        if (requestStatus) {
            searchRequestReason += `${requestStatus}`;
        }
        return searchRequestReason
    }

    const buildQueryRequestCreatedTimeStamp = () => {
        const { requestCreatedTimeStamp } = filter || {};
        let searchRequestCreatedTimeStamp = '';
        if (requestCreatedTimeStamp) {
            searchRequestCreatedTimeStamp += `${requestCreatedTimeStamp}`;
        }
        return searchRequestCreatedTimeStamp
    }

    const buildQueryrequestedBy = () => {
        const { requestedBy } = filter || {};
        let searchrequestedBy = '';
        if (requestedBy) {
            searchrequestedBy += `${requestedBy}`;
        }
        return searchrequestedBy
    }

    const buildQueryRequestReason = () => {
        const { requestReason } = filter || {};
        let searchRequestReason = '';
        if (requestReason) {
            searchRequestReason += `${requestReason}`;
        }
        return searchRequestReason
    }
    const buildQueryRequestNotes = () => {
        const { requestNotes } = filter || {};
        let searchRequestNotes = '';
        if (requestNotes) {
            searchRequestNotes += `${requestNotes}`;
        }
        return searchRequestNotes
    }
    const buildQueryStatusUpdatedTieStamp = () => {
        const { statusUpdatedTieStamp } = filter || {};
        let searchStatusUpdatedTieStamp = '';
        if (statusUpdatedTieStamp) {
            searchStatusUpdatedTieStamp += `${statusUpdatedTieStamp}`;
        }
        return searchStatusUpdatedTieStamp
    }
    const buildQueryStatusUpdatedReason = () => {
        const { statusUpdatedReason } = filter || {};
        let searchStatusUpdatedReason = '';
        if (statusUpdatedReason) {
            searchStatusUpdatedReason += `${statusUpdatedReason}`;
        }
        return searchStatusUpdatedReason
    }

    const setPage = (page = 1) => {
        props.getReturnApprovalsList(page, pageSize, buildQueryDeviceKey(), buildQueryRequestStatus(), buildQueryRequestCreatedTimeStamp(), buildQueryrequestedBy(),
            buildQueryRequestReason(), buildQueryRequestNotes(), buildQueryStatusUpdatedTieStamp(), buildQueryStatusUpdatedReason(), sortDirection, sortOrder);
        setPager(prevPager => {
            const totalPages = Math.ceil(props.totalRecords / pageSize);
            const visiblePages = 10;
            const pageOffset = Math.max(0, Math.floor((page - 1) / visiblePages) * visiblePages);
            const newPages = [];
            for (let i = pageOffset + 1; i <= Math.min(totalPages, pageOffset + visiblePages); i++) {
                newPages.push(i);
            }
            return {
                ...prevPager,
                currentPage: page,
                totalPages,
                pages: newPages,
            };
        });
    };
    useEffect(() => {
        const currentUpdatePager = getPager(props.totalRecords, 1, pageSize);
        setPager(currentUpdatePager);
    }, [props.totalRecords, pageSize]);

    useEffect(() => {
        setPage();
        props.setPageSizeGlobal(pageSize)
    }, [pageSize, isApprovalRejectedSuccess])

    const sendBackendRequest = useCallback((name, value) => {
        setFilter((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }, []);

    const debouncedSendRequest = useMemo(() => {
        return debounce(sendBackendRequest, 1000);
    }, [sendBackendRequest]);

    const searchInputValidation = (event) => {
        const input = event.target;
        const { value, name } = input;
        debouncedSendRequest(name, value);
        setFilterDisplay({
            ...filterDisplay,
            [name]: value
        });
    }

    const handleLoadReason = (inputValue, callback) => {
        props.getReasonForAsyncSelect(inputValue, callback);
    };

    const handleAddReasonFilter = (option) => {
        const { label, value } = option || {};
        debouncedSendRequest("requestReason", label);
        setFilterDisplay({
            ...filterDisplay,
            requestReason: label,
            requestReasonId: value
        });
    }


    const handleSearchClick = () => {
        setPage();
    };

    const handleKeypress = (e) => {
        if (e.key === 'Enter') {
            handleSearchClick();
        }
    };

    useEffect(() => {
        if (filter) {
            handleSearchClick();
        }
    }, [filter])

    //----------------------SORTING-------------------------------------
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortOrder, setSortOrder] = useState(null);

    const handleSort = (column) => {
        if (sortOrder === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortOrder(column);
            setSortDirection('asc');
        }
    };
    useEffect(() => {
        if (sortOrder && sortDirection) {
            setPage();
        }
    }, [sortOrder, sortDirection])

    //----------------------APPROVAL MODAL-------------------------------------

    const handleOpenApprovalAction = (ReturnStatus, requestId) => {
        props.setReturnStatus(ReturnStatus);
        props.setSelectedRequestId(requestId);
        props.openReturnApprovalActionModal();
    };

    const handleClose = () => {
        props.closeReturnApprovalActionModal();
    };

    return (
        <div className="page-content">
            <Card>
                <CardTitle className="p-2 mb-0 fs-5 fw-bold text-dark d-flex justify-content-between">
                    RETURN APPROVAL LIST
                    {/* <div className="d-flex gap-4 fw-bold">
                        <Button
                            className='fw-bold'
                            size='sm'
                            color='info'
                            outline
                            active={(filter && filter.requestStatus) === 'Submitted'}
                            onClick={() => {
                                setFilter({ requestStatus: 'Submitted' });
                                setFilterDisplay({ requestStatus: 'Submitted' });
                            }}
                        >Submitted
                        </Button>
                        <Button
                            className='fw-bold'
                            size='sm'
                            color='primary'
                            active={(filter && filter.requestStatus) === 'Approved'}
                            outline
                            onClick={() => {
                                setFilter({ requestStatus: 'Approved' });
                                setFilterDisplay({ requestStatus: 'Approved' });
                            }}
                        >Approved
                        </Button>
                        <Button
                            className='fw-bold'
                            size='sm'
                            color='danger'
                            active={(filter && filter.requestStatus) === 'rejected'}
                            outline
                            onClick={() => {
                                setFilter({ requestStatus: 'rejected' });
                                setFilterDisplay({ requestStatus: 'rejected' });
                            }}
                        >Rejected
                        </Button>
                    </div> */}
                </CardTitle>
            </Card>
            <Card>
                <CardBody>
                    {errorMessage && (
                        <Message
                            type="danger"
                            defaultMessage={errorMessage}
                            baseClassName="alert"
                        />
                    )}
                    <div style={{ maxHeight: "500px", overflowX: "auto" }}>
                        <Table className="table table-striped table-hover w-100 align-middle" size="sm" style={style.table}>
                            <thead className='overflow-hidden sticky-top' style={{ backgroundColor: "white", overflow: "hidden", zIndex: "10" }}>
                                <tr className="text-nowrap">
                                    <th style={{ maxWidth: "300px" }}>SERIAL #</th>
                                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('requestStatus')}>
                                        RETURN STATUS
                                        {sortOrder === 'requestStatus' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                    </th>
                                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('requestCreatedTimeStamp')}>
                                        RETURN INITIATED ON
                                        {sortOrder === 'requestCreatedTimeStamp' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                    </th>
                                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('requestedByDisplayName')}>
                                        RETURNED BY
                                        {sortOrder === 'requestedByDisplayName' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                    </th>
                                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('requestReason')}>
                                        REASON
                                        {sortOrder === 'requestReason' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                    </th>
                                    <th style={{ cursor: "pointer", maxWidth: "200px" }} onClick={() => handleSort('requestNotes')}>
                                        NOTES
                                        {sortOrder === 'requestNotes' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                    </th>
                                    {((filter && filter.requestStatus) !== 'Submitted') &&
                                        <>
                                            <th style={{ cursor: "pointer" }} onClick={() => handleSort('statusUpdatedTieStamp')}>
                                                APPROVED / REJECTED ON
                                                {sortOrder === 'statusUpdatedTieStamp' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                            </th>
                                            <th style={{ cursor: "pointer" }} onClick={() => handleSort('statusUpdatedReason')}>
                                                APPROVAL / REJECTION REASON
                                                {sortOrder === 'statusUpdatedReason' && (<i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />)}
                                            </th>
                                        </>
                                    }
                                    {((filter && filter.requestStatus) === 'Submitted') && <th>
                                        ACTIONS
                                    </th>
                                    }
                                </tr>
                                <tr>
                                    <th>
                                        <FormGroup>
                                            <Input
                                                className="form-control"
                                                type='number'
                                                size='sm'
                                                placeholder="Search"
                                                name="deviceKey"
                                                onChange={searchInputValidation}
                                                onKeyPress={handleKeypress}
                                                value={(filterDisplay && filterDisplay.deviceKey) || ""}
                                            />
                                        </FormGroup>
                                    </th>
                                    <th>
                                        <FormGroup>
                                            <Input
                                                className="form-control"
                                                type='select'
                                                size='sm'
                                                placeholder="Search"
                                                name="requestStatus"
                                                onChange={searchInputValidation}
                                                onKeyPress={handleKeypress}
                                                value={(filterDisplay && filterDisplay.requestStatus) || ""}
                                                disabled
                                            >
                                                <option value={"Submitted"}>Submitted</option>
                                                <option value={"Approved"}>Approved</option>
                                                <option value={"rejected"}>Rejected</option>
                                            </Input>
                                        </FormGroup>
                                    </th>
                                    <th>
                                        <FormGroup>
                                            <Input
                                                className="form-control"
                                                type='date'
                                                size='sm'
                                                placeholder="Search"
                                                name="requestCreatedTimeStamp"
                                                onChange={searchInputValidation}
                                                onKeyPress={handleKeypress}
                                                value={(filterDisplay && filterDisplay.requestCreatedTimeStamp) || ""}
                                            />
                                        </FormGroup>
                                    </th>
                                    <th>
                                        <FormGroup>
                                            <Input
                                                className="form-control"
                                                type='text'
                                                size='sm'
                                                placeholder="Search"
                                                name="requestedBy"
                                                onChange={searchInputValidation}
                                                onKeyPress={handleKeypress}
                                                value={(filterDisplay && filterDisplay.requestedBy) || ""}
                                            />
                                        </FormGroup>
                                    </th>
                                    <th>
                                        <FormGroup>
                                            <Async
                                                styles={{ ...customStyles, menuPortal: base => ({ ...base, zIndex: 10 }) }}
                                                placeHolder="Search"
                                                name="requestReason"
                                                defaultOptions
                                                isClearable
                                                menuPortalTarget={document.body}
                                                loadOptions={handleLoadReason}
                                                onChange={handleAddReasonFilter}
                                                onKeyPress={handleKeypress}
                                                value={filterDisplay && filterDisplay.requestReason ? { label: filterDisplay.requestReason, value: filterDisplay.requestReasonId } : ""}
                                            />
                                        </FormGroup>
                                    </th>
                                    <th>
                                        <FormGroup>
                                            <Input
                                                className="form-control"
                                                type='text'
                                                size='sm'
                                                placeholder="Search"
                                                name="requestNotes"
                                                onChange={searchInputValidation}
                                                onKeyPress={handleKeypress}
                                                value={(filterDisplay && filterDisplay.requestNotes) || ""}
                                            />
                                        </FormGroup>
                                    </th>
                                    {((filter && filter.requestStatus) !== 'Submitted') &&
                                        <>
                                            <th>
                                                <FormGroup>
                                                    <Input
                                                        className="form-control"
                                                        type='date'
                                                        size='sm'
                                                        placeholder="Search"
                                                        name="statusUpdatedTieStamp"
                                                        onChange={searchInputValidation}
                                                        onKeyPress={handleKeypress}
                                                        value={(filterDisplay && filterDisplay.statusUpdatedTieStamp) || ""}
                                                    />
                                                </FormGroup>
                                            </th>
                                            <th>
                                                <FormGroup>
                                                    <Input
                                                        className="form-control"
                                                        type='text'
                                                        size='sm'
                                                        placeholder="Search"
                                                        name="statusUpdatedReason"
                                                        onChange={searchInputValidation}
                                                        onKeyPress={handleKeypress}
                                                        value={(filterDisplay && filterDisplay.statusUpdatedReason) || ""}
                                                    />
                                                </FormGroup>
                                            </th>
                                        </>
                                    }
                                    {((filter && filter.requestStatus) === 'Submitted') && <th></th>}
                                </tr>
                            </thead>
                            <tbody>
                                {(returnApprovals && returnApprovals.length > 0) && !isGetReturnApprovalsPending ?
                                    returnApprovals.map((data, index) => (
                                        <tr key={index}>
                                            <td>{data.deviceList && data.deviceList.map((i) => {
                                                return (
                                                    <UITooltip
                                                        content={
                                                            <>
                                                                <div> Name: {i.name}</div>
                                                                <div>   Status: {i.isActive ? (
                                                                    <Badge color="success">Active</Badge>
                                                                ) : (<Badge color="danger">Inactive</Badge>)}
                                                                </div>
                                                            </>
                                                        }
                                                        id={`deviceDetails-${i.deviceId}`}
                                                    >
                                                        <Badge className="fs-6 p-2 me-2 mb-2" color="info" pill style={{ cursor: "pointer" }}>
                                                            {i.deviceKey}
                                                        </Badge>
                                                    </UITooltip>
                                                )
                                            })}
                                            </td>
                                            <td>{data.requestStatus || "NA"}</td>
                                            <td>{data.requestCreatedTimeStamp ? moment(data.requestCreatedTimeStamp).format("DD MMM YYYY") : "NA"}</td>
                                            <td>
                                                {data.requestedByDisplayName || "NA"} {`(${data.requestedByUserRole})`}<br />
                                                <small>{data.requestedByEmail}</small>
                                            </td>
                                            <td className="text-nowrap">{data.requestReason || "NA"}</td>
                                            <td>{data.requestNotes || "NA"}</td>
                                            {((filter && filter.requestStatus) !== 'Submitted') &&
                                                <>
                                                    <td>{data.statusUpdatedTieStamp ? moment(data.statusUpdatedTieStamp).format("DD MMM YYYY") : "NA"}</td>
                                                    <td>{data.statusUpdatedReason || "NA"}</td>
                                                </>
                                            }
                                            {((filter && filter.requestStatus) === 'Submitted') &&
                                                <td className="sticky-column bg-white text-nowrap">
                                                    <UITooltip id="accept" content={"Accept"}>
                                                        <button
                                                            type="button"
                                                            className="me-2 btn btn-sm btn-success"
                                                            onClick={() =>
                                                                handleOpenApprovalAction("Approved", data.id)
                                                            }
                                                        >
                                                            <i className="fas fa-thumbs-up"></i>
                                                        </button>
                                                    </UITooltip>
                                                    <UITooltip id="reject" content={"Reject"}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-danger"
                                                            onClick={() =>
                                                                handleOpenApprovalAction("rejected", data.id)
                                                            }
                                                        >
                                                            <i className="fas fa-thumbs-down"></i>
                                                        </button>
                                                    </UITooltip>
                                                </td>
                                            }
                                        </tr>
                                    ))
                                    : isGetReturnApprovalsPending ? (
                                        <tr>
                                            <td colSpan={9} align="center" className="p-4">
                                                <Skeleton type="body" />
                                                <VWLoading />
                                            </td>
                                        </tr>
                                    ) :
                                        <tr>
                                            <td colSpan={9}>
                                                <NoRecord />
                                            </td>
                                        </tr>
                                } </tbody>
                        </Table>
                    </div >
                </CardBody>
                <CardFooter>
                    {props.returnApprovals?.length > 0 ?
                        <VWPagination
                            pager={pager}
                            setPage={setPage}
                            totalRecords={props.totalRecords}
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                        /> : null
                    }
                </CardFooter>
            </Card>
            <VWModel
                header={returnStatus === "Approved" ? "APPROVE RETURN" : "REJECT RETURN"}
                isOpen={isReturnApprovalActionModalOpen}
                handleClose={handleClose}
            >
                <ApproveOrRejectReturn
                    handleClose={handleClose}
                />
            </VWModel>
        </div>
    )
}

const mapStateToProps = (state) => ({
    returnStatus: state.returnApprovals.action,
    isReturnApprovalActionModalOpen: state.returnApprovals.isReturnApprovalActionModalOpen,
    returnApprovals: state.returnApprovals.returnApprovals,
    errorMessage: state.returnApprovals.returnApprovalListError,
    totalRecords: state.returnApprovals.totalRecords,
    isGetReturnApprovalsPending: state.returnApprovals.isGetReturnApprovalsPending,
    isApprovalRejectedSuccess: state.returnApprovals.isApprovalRejectedSuccess,
    currentProfile: state.login.currentProfile,
});

const mapDispatchToProps = (dispatch) => ({
    openReturnApprovalActionModal: () => dispatch(openReturnApprovalActionModal()),
    closeReturnApprovalActionModal: () => dispatch(closeReturnApprovalActionModal()),
    setPageSizeGlobal: (pageSize) => dispatch(setPageSizeGlobalReturn(pageSize)),
    getReturnApprovalsList: (page, pageSize, searchDeviceKey, searchRequestStatus, searchRequestCreatedTimeStamp, searchrequestedBy, searchRequestReason, searchRequestNotes,
        searchStatusUpdatedTieStamp, searchStatusUpdatedReason, sortDirection, sortOrder) => dispatch(getReturnApprovalsList(page, pageSize, searchDeviceKey, searchRequestStatus,
            searchRequestCreatedTimeStamp, searchrequestedBy, searchRequestReason, searchRequestNotes, searchStatusUpdatedTieStamp, searchStatusUpdatedReason, sortDirection, sortOrder)),
    getReasonForAsyncSelect: (inputValue, callback) => dispatch(getReasonForAsyncSelect(inputValue, callback)),
    setReturnStatus: (action) => dispatch(setReturnStatus(action)),
    setSelectedRequestId: (requestId) => dispatch(setSelectedRequestId(requestId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReturnApprovalsList);